/**
 * HLS Stw CuePoint
 */
define([], function () {
  var hlsCuePoint = {
    HLS_TRACK_ID: 'hlsTrackId',
    HLS_SEGMENT_ID: 'hlsSegmentId'
  };

  return hlsCuePoint;
});



//////////////////
// WEBPACK FOOTER
// ./src/base/cuepoints/HlsCuePoint.js
// module id = 41
// module chunks = 0